import React, { useEffect, useState } from 'react';
import axios from "axios";
import { API_URL } from '../Constant';
import { isNumeric, isMonthAndYearEmpty,getButtonDisabledStates,getStatusFlagValue } from '../Custom/Custom';
import messages from '../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import {showLoading } from 'react-global-loading';

const SixtySevenNecessaryItemsData = ({
  SixtySevenNecessaryItemsPrice = [],
  districtCode,
  dateName,
  monthName,
  yearName,
  config,
  resetMonthAndYearField,
  userInfoObject,
  titlesData,
  storedLanguage,
  priceTitle,
  othersTitle,
  titlesHindi,
  payload 
}) => {
 
  const [itemData, setItemData] = useState({});
  const [loading, setLoading] = useState(false);
  
  let srNo='';
  let moongDal=0;
	let urdDal=0
	let potato=0
	let fish=0
	let cycleTyre=0
	let cycleTube=0
	let medicines=0
 let stainlessSteelUtensile=0
 let districtAndDivision=false;
 const static_items_code_1=["157", "158", "159", "160","161","162","163","164","165","166","167",
  "168","169","170","171","114","115"
 ]
 const static_items_code_2=["118", "119", "120", "121","122","123","124","125","126","127","128",
  "129","130","131","132","133","134"
 ]
 const static_items_code_3=["142", "143", "144", "145","146","147","148"]

 const static_items_code_4=["150", "151", "152", "153","154","172","173"]

  const navigate = useNavigate();

  const {
    isSaveBtnDisable,
    isSubmitBtnDisable,
    isRejectBtnDisable
  } = getButtonDisabledStates(payload, userInfoObject);
 


 

  let headQuarterRemark=[
    'Price is Too Low.',
	  'Price is too High.',
	  'Price does not match with unit.' ,
	  'Price does not match with variety.',
    'Others.'
  ]
  let otherRemark=[
    'Production is low',
    'Production is high',
    'Less supply',
    'High supply',
    'Not Available.',
    'On sale.',
    'Seasonal effect',
    'Discounted Item',
    'Other.'
  ]

  useEffect(() => {
    if (!SixtySevenNecessaryItemsPrice.length) return;
     const initialItemData = {};
    SixtySevenNecessaryItemsPrice.forEach(item => {
      initialItemData[item.item_code] = {
        PRICE: item.PRICE === null ? '0' : item.PRICE,
        COMMENTS: item.COMMENTS === null ? '' : item.COMMENTS,
        statusFlag: item.statusFlag,
        style: {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 3px'
        },
        isRequiredRemark: false,
        isRejectStatus: item.statusFlag === '6'
        };
    });
     setItemData(initialItemData);
  }, [SixtySevenNecessaryItemsPrice]);


// Helper to block input unless all required fields are present
  const isFormReady = () => {
    if (!isMonthAndYearEmpty(monthName, yearName)) return false;
    if (!dateName) {
      toast.error("Please select date.", messages.COLOR_RED);
      return false;
    }
    if (!districtCode) {
      toast.error("Please select district.", messages.COLOR_RED);
      return false;
    }
    return true;
  };

// Handle check box On Change ********************************
  const handleCheckboxChange = (item_code, field, checked) => {
    if (!isFormReady()) {
      return;
    }
    let isRequiredRemark = ((itemData[item_code]?.COMMENTS && itemData[item_code]?.COMMENTS !=='NA')? false : true); //required validation for Remarks
    setItemData(prevItemData => ({
      ...prevItemData,
      [item_code]: {
        ...prevItemData[item_code],
        [field]: !prevItemData[item_code][field],
        'isRequiredRemark': isRequiredRemark
      }
    }));
  };









  const handleOnChange = (item_code, field, newValue) => {
     if (!isFormReady()) return;
     let isRequiredRemark = false;

    if (field === 'PRICE' && !isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    if (field === 'COMMENTS' && itemData[item_code].isRequiredRemark === false
      && newValue === '' && (newValue === '' || itemData[item_code].COMMENTS === '' || itemData[item_code].COMMENTS === 'NA' ||
        itemData[item_code].style.borderColor==="rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red"
      )) {
      isRequiredRemark = true
    }

    // Remove validation logic from here

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [item_code]: {
          ...prevItemData[item_code],
          [field]: newValue,
          'isRequiredRemark': isRequiredRemark
        }
      };

      return updatedItemData;
    });


  };




  const validateItemVariationPrice = (item_code, field, newValue, average, variation) => {
    if (!isFormReady()) return;

      let dynamicStylesForTextBox = {}
      let isRequiredRemark = false

    if (newValue !== 0) {
      let dif = average * variation / 100;
      if (variation === 0 || dif === 0) {
        return;
      }
      if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
        toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
        dynamicStylesForTextBox = {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        newValue = dynamicStylesForTextBox
        if (itemData[item_code].COMMENTS === 'NA' || itemData[item_code].COMMENTS === '') {
          isRequiredRemark = true
        }


      } else {

        dynamicStylesForTextBox = {
          borderColor: '#dcdfe1',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 6px'
        }
        isRequiredRemark = false
        newValue = dynamicStylesForTextBox


      }
    }


        setItemData(prevItemData => ({
          ...prevItemData,
          [item_code]: {
            ...prevItemData[item_code],
            [field]: newValue,
            'isRequiredRemark': isRequiredRemark
          }
        }));



  };






  const handleAction = async (actionType) => {

   
      // Validate date and district for the 'SAVE' action
      if (actionType === 'SAVE' && (!dateName || !districtCode)) {
        if (!dateName) {
           toast.error('Please select a date.', messages.COLOR_RED);
           return;
        }
        if (!districtCode) {
            toast.error('Please select a district.', messages.COLOR_RED);
            return;
        }
    }
    let clickButtonStatusFlag = getStatusFlagValue(actionType, userInfoObject.userLevel) //button click status flag
    let check = 0;
    let statusFlag = '';
    const customItemCodes = [];
    for (let item_code_id in itemData) {
      let PRICE = itemData[item_code_id].PRICE;
      let COMMENTS = itemData[item_code_id].COMMENTS;
      let isRequiredRemark = itemData[item_code_id].isRequiredRemark;
      let isRejectStatus = itemData[item_code_id].isRejectStatus;
      let item_code= item_code_id;

      statusFlag = (itemData[item_code_id].statusFlag === '') ?
        clickButtonStatusFlag
        :
        itemData[item_code_id].statusFlag //data base Statusflag

      if (actionType === "REJECT" && isRejectStatus) {
        check++;
        if (isRequiredRemark) {
          toast.error(messages.REMARK_MSG, messages.COLOR_RED);
          return false;
        }
        statusFlag = clickButtonStatusFlag
      }

      if (actionType === "ACCEPT" || actionType === "SAVE") { //Accept Button click
        statusFlag = clickButtonStatusFlag
      }

      if (actionType === "SUBMIT") { //Submit Button click
        statusFlag = clickButtonStatusFlag;
      }

      if ((PRICE === '' || PRICE === null)) {
          PRICE = "0";
       }
      if (isRequiredRemark && (COMMENTS === 'NA' || COMMENTS === '')) {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (COMMENTS === '' || COMMENTS == null) {
        COMMENTS = 'NA';
      }


      const customObject = {
        PRICE: PRICE,
        COMMENTS: COMMENTS,
        item_code:item_code,
        statusFlag: statusFlag,
        source: '1',
        priceDate: dateName,
        priceMonth: monthName  >= 10 ? monthName.toString() : `0${monthName}`,
        priceYear: yearName

      };

      customItemCodes.push(customObject);
    };


    if (actionType === "REJECT" && check === 0) {
      toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
      return false;
    }



      const postData = {
        itemCodes: customItemCodes,
        payload: {
          districtCode,
          "monthName": monthName  >= 10 ? monthName.toString() : `0${monthName}`,
          yearName,
          dateName,
          buttonType: actionType
        }
      };

      // return false;


      try {
      showLoading(true)
      const response = await axios.post(`${API_URL}api/otherPrices/getSixtySevenNecessaryItemsFormDataSaveToDB`, postData, config);
     if (response.data.status) {
        toast.success(response.data.message, messages.COLOR_RED);
       
        // resetMonthAndYearField();
      } else {
        toast.error(response.data.message, messages.COLOR_RED);
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false)
      resetForm()
    }
  };


  const resetForm = () => {
    const initialItemData = {};
    SixtySevenNecessaryItemsPrice.forEach(item => {
      initialItemData[item.item_code] = {
        PRICE: '',
        remark: '',
        statusFlag: '',
        style: {
          borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
          borderStyle: 'solid',
          borderWidth: '1px 1px 1px 3px'
        },
        isRequiredRemark: false,
        isRejectStatus: false
      };
    });

    setItemData(initialItemData);
    resetMonthAndYearField();
  };


  const checkBoxcheckedLength = () => {

    const filteredData = Object.fromEntries(
      Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
    );
    return Object.keys(filteredData).length

  }



  //Handle merge table data ****************
const getItemTableData=(item_name,itemsObject,mergeColumn)=>{

// Moong Dal
  if(item_name.trim()==='Moong Dal'){
     if(itemsObject.moongDal ===0){
       return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
      }
  }

//Urd Dal
    if(item_name.trim()==='Urd Dal'){
         if(itemsObject.urdDal ===0){
            return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
            }
    }
   
//Potato
    if(item_name.trim()==='Potato'){
       if(itemsObject.potato ===0){
          return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }

//Fish
    if(item_name.trim()==='Fish'){
        if(itemsObject.fish ===0){
          return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }

//Cycle tyre
    if(item_name.trim()==='Cycle tyre'){
      if(itemsObject.cycleTyre ===0){
          return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }

//Cycle tube
    if(item_name.trim()==='Cycle tube'){
        if(itemsObject.cycleTube ===0){
           return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }

//Medicines
    if(item_name.trim()==='Medicines'){
      if(itemsObject.medicines ===0){
          return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }
//Stainless steel utensile
    if(item_name.trim()==='Stainless steel utensile'){
      if(itemsObject.stainlessSteelUtensile ===0){
          return <td rowSpan={((mergeColumn === 1 ?2:''))}>{item_name}</td> 
          }
    }
 }



  return (
    <div className="card-body">
      {/* <ToastContainer /> */}
       <div className="table-responsive">
        <table className="table table-bordered consumer_retail_table">
          <thead>
            <tr>
              <th>{storedLanguage === 'hi' ? othersTitle.hi.SERIAL_NO : othersTitle.en.SERIAL_NO}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Item_Catagories : priceTitle.en.Item_Catagories}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.Varities : priceTitle.en.Varities}</th>
              <th>{storedLanguage === 'hi' ? titlesHindi.hi.UNIT : titlesHindi.en.UNIT}</th>
              <th>{storedLanguage === 'hi' ? othersTitle.hi.CURRENT_PRICE : othersTitle.en.CURRENT_PRICE}</th>
              <th>{storedLanguage === 'hi' ? priceTitle.hi.REMARKS : priceTitle.en.REMARKS}</th>
              <th>{storedLanguage === 'hi' ? othersTitle.hi.REJECT_STATUS : othersTitle.en.REJECT_STATUS}</th>
            </tr>
          </thead>
          <tbody>
            {SixtySevenNecessaryItemsPrice.map((item, index) => {

                    srNo=index
                    let mergeColumn=0;
                    let romanDigit='';
                    if(item.item_name.trim() === 'Moong Dal' ||  item.item_name.trim() ==='Urd Dal' 
                    || item.item_name.trim() ==='Potato' || item.item_name.trim() ==='Fish' ||
                    item.item_name.trim() ==='Cycle tyre'  || item.item_name.trim() ==='Cycle tube' ||
                    item.item_name.trim() ==='Medicines'  || item.item_name.trim() ==='Stainless steel utensile'){
                   
            
                              //  Item for 'Moong Dal' condition

                              if(item.item_code==='108'){ //First Ittrm Idsecont Item Id
                                   srNo++;
                                  romanDigit=`-I`
                                  mergeColumn++;
                              }
                              if(item.item_code==='109'){ // Second Item Id
                                moongDal++;
                                romanDigit=`-II`
                                mergeColumn++;
                            }


                            
                        //  Item for 'Urd Dal' condition
                          if(item.item_code==='110'){ //First Ittrm Idsecont Item Id
                            romanDigit=`-I`
                            mergeColumn++;
                          }
                        if(item.item_code==='111'){ // Second Item Id
                            srNo=srNo-1;
                            urdDal++;
                            romanDigit=`-II`
                          
                        }


                      //  Item for 'POTATO' condition
                      if(item.item_code==='113'){ 
                        srNo=srNo-1;
                        romanDigit=`-I`
                        mergeColumn++;
                      }
                    if(item.item_code==='490'){ 
                        srNo=srNo-2;
                        potato++;
                        romanDigit=`-II`
                      
                    }
                      //  Item for 'Fish' condition
                      if(item.item_code==='116'){ 
                        srNo=srNo-2;
                        romanDigit=`-I`
                        mergeColumn++;
                      }
                    if(item.item_code==='117'){ 
                        srNo=srNo-3;
                        fish++;
                        romanDigit=`-II`
                      
                    }
                      //  Item for 'Cycle tyre' condition
                      if(item.item_code==='136'){ 
                        srNo=srNo-3;
                        romanDigit=`-I`
                        mergeColumn++;
                      }
                    if(item.item_code==='135'){ 
                        srNo=srNo-4;
                        cycleTyre++;
                        romanDigit=`-II`
                      
                    }
                      //  Item for 'Cycle tube' condition
                      if(item.item_code==='137'){ 
                        srNo=srNo-4;
                        romanDigit=`-I`
                        mergeColumn++;
                      }
                    if(item.item_code==='138'){ 
                        srNo=srNo-5;
                        cycleTube++;
                        romanDigit=`-II`
                      
                    }

                      //  Item for 'Medicines' condition
                      if(item.item_code==='140'){ 
                        srNo=srNo-5;
                        romanDigit=`-I`
                        mergeColumn++;
                      }
                    if(item.item_code==='141'){ 
                        srNo=srNo-6;
                        medicines++;
                        romanDigit=`-II`
                      
                    }

                  //  Item for 'Stainless steel utensile' condition
                  if(item.item_code==='148'){ 
                    srNo=srNo-6;
                    romanDigit=`-I`
                    mergeColumn++;
                  }
                if(item.item_code==='149'){ 
                    srNo=srNo-7;
                    stainlessSteelUtensile++;
                    romanDigit=`-II`
                  
                }



                      
                        

            }else{

                if(item.item_code==='112'){
                  srNo=srNo-1;
                }else if(static_items_code_1.includes(item.item_code)){
                  srNo=srNo-2;
                 }else if(static_items_code_2.includes(item.item_code)){
                  srNo=srNo-3;
                 }else if(item.item_code==="139"){
                  srNo=srNo-5;
                 }else if(static_items_code_3.includes(item.item_code)){
                  srNo=srNo-6;

                 }else if(static_items_code_4.includes(item.item_code)){
                  srNo=srNo-7;
                 } else{
                  srNo++;
                }
              
            }

         

        let itemsObject={
          moongDal:moongDal,
          urdDal:urdDal,
          potato:potato,
          fish:fish,
          cycleTyre:cycleTyre,
          cycleTube:cycleTube,
          medicines:medicines,
          stainlessSteelUtensile:stainlessSteelUtensile
        }
        
        if( (userInfoObject.userLevel==='DISTRICT LEVEL' ||  userInfoObject.userLevel==='DIVISION LEVEL') ){
          districtAndDivision=true;
        }

              return   <>
             
             { (item.item_name.trim() !== 'Moong Dal' &&  item.item_name.trim() !=='Urd Dal' 
              && item.item_name.trim() !=='Potato' && item.item_name.trim() !=='Fish'  && 
              item.item_name.trim() !=='Cycle tyre'  && item.item_name.trim() !=='Cycle tube' &&
              item.item_name.trim() !=='Medicines'  && item.item_name.trim() !=='Stainless steel utensile') ? 
                        <tr key={`tbody_1${index}`}>
                           <td><b>{srNo}{romanDigit}</b></td>
                          <td>{item.item_name}</td>
                          <td>{item.variety}</td>
                          <td>{item.item_unit_name}</td>
                          
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={itemData[item.item_code]?.PRICE !== undefined ? itemData[item.item_code].PRICE : '0'} // Display 0 if price is 0
                              maxLength="12"
                              name={`PRICE${[item.item_code]}`}
                              id={`PRICE${item.item_code}`}
                              style={itemData[item.item_code]?.style || {}}
                              onChange={e => handleOnChange(item.item_code, 'PRICE', e.target.value)}
                              onBlur={e => {
                               validateItemVariationPrice(item.item_code, 'style', parseFloat(e.target.value), item.average, item.variance_limit); // Validation logic added here
                              }}
                            />
                          </td>

                          <td>
                            {
                              userInfoObject.userLevel === "HEAD QUARTER" ?
                              item.COMMENTS !== '' &&  !headQuarterRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                              otherRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.COMMENTS}</label>
                              
                              :
                              item.COMMENTS !== ''  &&  !otherRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                              headQuarterRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.COMMENTS}</label>
                  
                              }

                        
                              <select
                                
                                  name={`COMMENTS${index}`}
                                  id={`COMMENTS${index}`}
                                  className="form-select"
                                  // value={itemData[item.itemCode]?.remarks || ''}
                                  value={itemData[item.item_code]?.COMMENTS || ''}
                                  onChange={e => handleOnChange(item.item_code, 'COMMENTS', e.target.value)}
                                >
                                  <option value="">[---Select---]</option>
                                    
                                      { userInfoObject.userLevel === "HEAD QUARTER" ?
                                            headQuarterRemark.map((remarkItem,i)=>{
                                              return (
                                              <option value={remarkItem}>{remarkItem}</option>
                            
                                            )})
                                        :
                                            otherRemark.map((remarkItem,i)=>{
                                              return (
                                              <option value={remarkItem}>{remarkItem}</option>
                            
                                            )})
                                      }

                                </select>



                              {(itemData[item.item_code]?.isRequiredRemark !== undefined && itemData[item.item_code]?.isRequiredRemark) ?
                                (
                                  <div style={{ color: 'red', marginTop: '10px' }}>
                                    Please Select the Remark
                                  </div>
                                )
                                :
                                ''
                              }


                          </td>

                          <td className={itemData[item.item_code]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              onChange={(event) => handleCheckboxChange(item.item_code, 'isRejectStatus', event.target.checked)}
                              checked={itemData[item.item_code]?.isRejectStatus || false}
                              disabled={districtAndDivision  ? 'disabled' : ''}
                            />
                          </td>
                        </tr>
              :
                       <tr key={`tbody_1${index}`}>
                        <td><b>{srNo}{romanDigit}</b></td>
                          {getItemTableData(item.item_name,itemsObject,mergeColumn)}
                          <td>{item.variety}</td>
                          <td>{item.item_unit_name}</td>

                          <td>
                            <input
                              type="text"
                              className="form-control"
                              // value={prices[index]}
                              // value={itemData[item.item_code]?.PRICE}
                              value={itemData[item.item_code]?.PRICE !== undefined ? itemData[item.item_code].PRICE : '0'} // Display 0 if price is 0

                              maxLength="12"
                              name={`PRICE${[item.item_code]}`}
                              id={`PRICE${item.item_code}`}
                              style={itemData[item.item_code]?.style || {}}
                              onChange={e => handleOnChange(item.item_code, 'PRICE', e.target.value)}
                              onBlur={e => {
                                validateItemVariationPrice(item.item_code, 'style', parseFloat(e.target.value), item.average, item.variance_limit); // Validation logic added here
                               }}
                            />
                          </td>

                          <td>
                            {
                              userInfoObject.userLevel === "HEAD QUARTER" ?
                              item.COMMENTS !== '' &&  !headQuarterRemark.includes(itemData[item.item_code]?.PRICE) &&
                              otherRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.COMMENTS}</label>
                              
                              :
                              item.COMMENTS !== ''  &&  !otherRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                              headQuarterRemark.includes(itemData[item.item_code]?.COMMENTS) &&
                                <label className="text-danger" style={{ fontSize: '12px' }}>*{item.COMMENTS}</label>
                  
                              }

                        
                              <select
                               name={`COMMENTS${index}`}
                               id={`COMMENTS${index}`}
                               className="form-select"
                                value={itemData[item.item_code]?.COMMENTS || ''}
                                onChange={e => handleOnChange(item.item_code, 'COMMENTS', e.target.value)}
                                // onChange={(e) => handleRemarkChange(index, e.target.value)}
                                >
                                  <option value="">[---Select---]</option>
                                
                                  { userInfoObject.userLevel === "HEAD QUARTER" ?
                                        headQuarterRemark.map((remarkItem,i)=>{
                                          return (
                                          <option value={remarkItem}>{remarkItem}</option>
                        
                                        )})
                                    :
                                        otherRemark.map((remarkItem,i)=>{
                                          return (
                                          <option value={remarkItem}>{remarkItem}</option>
                        
                                        )})
                                  }

                                </select>



                              {(itemData[item.item_code]?.isRequiredRemark !== undefined && itemData[item.item_code]?.isRequiredRemark) ?
                                (
                                  <div style={{ color: 'red', marginTop: '10px' }}>
                                    Please Select the Remark
                                  </div>
                                )
                                :
                                ''
                              }


                          </td>

                          <td className={itemData[item.item_code]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name={`status${index}`}
                              id={`status${index}`}
                              onChange={(event) => handleCheckboxChange(item.item_code, 'isRejectStatus', event.target.checked)}
                              checked={itemData[item.item_code]?.isRejectStatus || false}
                              disabled={districtAndDivision  ? 'disabled' : ''}
                            />
                          </td>
                        </tr>
              

               }
              </>

      })}


          </tbody>
        </table>
      </div>

      <div className="row">
        <div className="col-12 text-center pt-3">
              <button
                onClick={() => handleAction('SAVE')}
                type="button"
                className={`btn btn_orange mx-1 ${isSaveBtnDisable ? 'disabled' : ''}`}
              >Save
              </button>


          {(userInfoObject.userLevel==='DISTRICT LEVEL' || userInfoObject.userLevel==='DIVISION LEVEL') &&

              <button
              onClick={() => handleAction('SUBMIT')}
              type="submit"
              className={`btn btn_orange mx-1 ${isSubmitBtnDisable || checkBoxcheckedLength() > 0 ? 'disabled' : ''}`}
              >Submit
              </button>

          }

          {userInfoObject.userLevel === 'HEAD QUARTER' &&
            <>
              <button
                  onClick={() => handleAction('REJECT')}
                  type="button"
                  className={`btn btn_orange mx-1 ${isRejectBtnDisable ? 'disabled' : ''}`}
                >Reject
              </button>
            </>
          }

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={resetForm}           
            >
            Reset
          </button>
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={() => navigate("/dashboard")}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default SixtySevenNecessaryItemsData;
